module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "itembank-form"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Content Article")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Create")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Tambah Artikel")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-form"
  }, [(this.errors.length > 0) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _c('ul', _vm._l((this.errors), function(message, key) {
    return _c('li', {
      key: key
    }, [_vm._v(_vm._s(message))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('section_id') >= 0
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Pilih Section *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.section_id),
      expression: "form.section_id"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "section_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.listSection), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('name') >= 0
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Judul *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('description') >= 0
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Deskripsi")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.description),
      expression: "form.description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "description", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('link') >= 0 || !_vm.is_url_valid, 'has-success': _vm.is_url_valid
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Link")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.link),
      expression: "form.link"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "link", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Upload Gambar")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.form.picture) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.form.picture
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('app-imagecropper', {
    attrs: {
      "aspectRatio": 0.5
    },
    on: {
      "finished": function($event) {
        return _vm.handleChangePicture($event)
      }
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('status') >= 0
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.status),
      expression: "form.status"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "PUBLISHED"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "HIDDEN"
    }
  }, [_vm._v("Hidden")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [(_vm.$route.query.id) ? _c('button', {
    staticClass: "btn btn-success btn-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Simpan Perubahan")]) : _c('button', {
    staticClass: "btn btn-success btn-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Simpan")])])])])])])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Form Artikel")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "help-text"
  }, [_vm._v("must start with "), _c('strong', [_vm._v("http://")]), _vm._v(" or "), _c('strong', [_vm._v("https://")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01585795","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home_setting/article/Form.vue
// module id = 1273
// module chunks = 0